import { useTranslation } from 'react-i18next';

export default function Title() {
  const { t } = useTranslation('pdp');

  return (
    <div
      data-cy="wtb-title"
      className="flex items-center justify-between text-lg font-bold tracking-wide text-black"
    >
      {t('getNotifiedTitle')}
    </div>
  );
}
